import React from 'react';
import {
  UniversityExperienceInfo,
  UniversityGraduatedInfo,
  UniversityStudentInfo,
  UniversityTeacherInfo
} from 'icons';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { IAllUniversities, UniversityTypes } from 'modules/universities';

interface IProps {
  university?: IAllUniversities;
}

const FirstSection: React.FC<IProps> = ({ university }) => {
  const t = useTranslations();
  
  return (
    <div className="rounded-xl bg-white p-4 px-6 shadow-sm">
      <div className="flex flex-col items-center justify-center space-y-4 text-center sm:flex-row sm:items-start sm:justify-normal sm:space-x-4 sm:space-y-0 sm:text-left">
        {university?.logo ? (
          <div className="relative max-h-20 min-h-20 min-w-20 max-w-20 overflow-hidden rounded-full">
            <Image
              priority
              fill
              className="object-cover"
              src={university?.logo}
              alt={university?.name?.slice(0, 10) || 'University Logo'}
              title='Universitet logosi'
            />
          </div>
        ) : (
          <div className="relative flex max-h-20 min-h-20 min-w-20 max-w-20 items-center justify-center overflow-hidden rounded-full bg-gray-50">
            <Image
              priority
              width={20}
              height={20}
              className="object-cover"
              src="/images/default-no-image.webp"
              alt={university?.name?.slice(0, 10) || 'University Logo'}
              title='Universitet logosi'
            />
          </div>
        )}
        <div>
          <h2 className="text-sm font-semibold md:text-lg">{university?.name}</h2>
          <p className="my-3 text-xs text-gray-500 md:text-sm">{university?.description}</p>
        </div>
      </div>

      {university?.type === UniversityTypes.PRIVATE && (
        <div className="mt-3 hidden grid-cols-1 gap-4 md:grid md:grid-cols-4 lg:grid-cols-4">
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityStudentInfo />
            <p className="text-xs text-gray-400">{t('Talaba')}</p>
            <p className="text-sm font-medium text-gray-800">{university?.students_count || '-'}</p>
          </div>
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityGraduatedInfo />
            <p className="text-xs text-gray-400">{t('Bitiruvchi')}</p>
            <p className="text-sm font-medium text-gray-800"> {university?.graduate_students_count || '-'}</p>
          </div>
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityTeacherInfo />
            <p className="text-xs text-gray-400">{t('Yonalishlar')}</p>
            <p className="text-sm font-medium text-gray-800"> {university?.courses_count || '-'}</p>
          </div>
          <div className="flex flex-col items-center justify-center rounded-lg bg-gray-50 p-1">
            <UniversityExperienceInfo />
            <p className="text-xs text-gray-400">{t('Tajriba')}</p>
            <p className="text-sm font-medium text-gray-800">{university?.experience_years_count || '-'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FirstSection;
